import React from 'react';
import { observer } from 'mobx-react';

import DefaultKitItem from '~views/ShoppingBagTab/CartSidebarItems/CartItem/CartItemDescription/KitDetails/KitDetailComponents/DefaultKitItem';

import ICartItem from '~domain/entities/CartItem/ICartItem';
import { IKitItem } from '~api/KitsAPI/utils/IKits';
import { StyledKitItemsWrapper } from './KitDetailsStyles';
import { classes } from '~utils/ClassNames';

interface IKitDetailsProps {
    cartItem: ICartItem;
}

const kitItemComponentMap = {
    default: DefaultKitItem
};

const kitItemsName = 'cart-kit-items';
export const wrapperClass = classes(kitItemsName);

export const KitDetails = observer(({ cartItem }: IKitDetailsProps) => {
    const { kitInfo } = cartItem;

    return (
        <StyledKitItemsWrapper className={wrapperClass}>
            {kitInfo?.kitItems.map((item: IKitItem) => {
                const kitItemType = item?.type as keyof typeof kitItemComponentMap;
                const KitItemComponent = kitItemComponentMap[kitItemType];

                return <KitItemComponent kitItem={item} />;
            })}
        </StyledKitItemsWrapper>
    );
});
